var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C12.3009 2.04488 8.76597 3.53429 6.15013 6.15013C3.53429 8.76597 2.04488 12.3009 2 16C2.04488 19.6991 3.53429 23.234 6.15013 25.8499C8.76597 28.4657 12.3009 29.9551 16 30C19.6991 29.9551 23.234 28.4657 25.8499 25.8499C28.4657 23.234 29.9551 19.6991 30 16C29.9551 12.3009 28.4657 8.76597 25.8499 6.15013C23.234 3.53429 19.6991 2.04488 16 2ZM24 17H17V24H15V17H8V15H15V8H17V15H24V17Z",
    fill: "#672EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilter);
export default __webpack_public_path__ + "static/media/add-filter.000e984892e8a533226d39abc0f51126.svg";
export { ForwardRef as ReactComponent };